import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {SkillsService} from "../../services/skills-service.service";

export class SkillsMultiSelectCtrl implements IController {

  selectedIds: any;
  excludeIds: string[];
  options: any[];
  optionIds: string[];
  ngPlaceholder: any;
  isDisabled: any;
  isRequired: any;
  onChange: Function;

  public selectedText: any;
  public selectedSkills: any;
  public skills: any[];

  constructor(private $mdPanel, private $element, private $skills, private $translate, private skillsService: SkillsService) {
  }

  $onInit() {
    this.skillsService.getAll()
      .then((skills: any) => {
        this.skills = skills;
        this._setSelectedSkills();
      })
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedSkills();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];
    const excludeIdsRef = this.excludeIds;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'skills';
        this.selectedIdsRef = selectedIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }
        this.onChange({ids: selectedIds});
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({ids: []});
  }

  private _setSelectedSkills() {
    if (!!this.selectedIds) {
      this.selectedSkills = _.filter(this.skills, (s) => {
        return _.includes(this.selectedIds, s.id);
      })
      this._setSelectedText();
    } else {
      this.selectedSkills = [];
      this._setSelectedText();
    }

  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");
    _.forEach(this.selectedSkills, (skill, i) => {
      string += this.$translate.instant(skill.name);
      if ((i + 1) < this.selectedSkills.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedIds[0] + ` +${this.selectedIds.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.skills')
  .component('skillsMultiSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedIds: '<',
      excludeIds: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      isDisabled: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./skills-multi-select.html').default,
    controller: SkillsMultiSelectCtrl
  });
